import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the tableBalanceHistorysView.
 * @extends JetView
 */
export default class tableBalanceHistorysView extends JetView {
    /**
     * Configures the view.
     * @returns {Object} Configuration object for the view.
     */
    config() {
        const id_partner = this.getParam('partner', true); // Retrieve partner ID from parameters
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance

        /**
         * Marks old values based on specified conditions.
         * @param {number} value - The value to evaluate.
         * @param {Object} config - Configuration object.
         * @returns {Object} CSS styles for the background.
         */
        function mark_old(value, config) {
            var num = webix.Number.parse(value, {
                decimalSize: 2,
                groupSize: 3,
                decimalDelimiter: '.',
                groupDelimiter: ',',
            });
            if (num > 30 && num < 99) {
                return { background: 'orange' }; // Orange background for values between 30 and 99
            }
            if (num > 100) {
                return { background: 'red' }; // Red background for values greater than 100
            }
        }

        return {
            rows: [
                {
                    cols: [
                        {
                            view: 'treetable', // Treetable view for displaying data
                            id: 'datatable', // Unique ID for the datatable
                            css: 'webix_header_border webix_data_border', // CSS classes for styling
                            scheme: {
                                $change: function (item) {
                                    // Change event for item updates
                                    if (item.BalanceEnd != item.BalanceEndCalc) {
                                        item.$css = { background: '#FFAAAA' }; // Highlight changed items
                                        if (item.BalanceEnd > item.BalanceEndCalc) {
                                            item.BalanceGap = item.BalanceEnd - item.BalanceEndCalc; // Calculate balance gap
                                        } else {
                                            item.BalanceGap = item.BalanceEndCalc - item.BalanceEnd; // Calculate balance gap
                                        }
                                    }
                                },
                            },
                            columns: [
                                {
                                    id: 'Partner', // Column ID
                                    header: _('Partner'), // Column header with localization
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                    template: function (obj, common) {
                                        // Template for displaying partner information
                                        if (obj.$group)
                                            return (
                                                common.treetable(obj, common) +
                                                "<span class='partner " +
                                                obj.Partner +
                                                "'></span>"
                                            );
                                        return "<span class='partner " + obj.Partner + "'></span>";
                                    },
                                },
                                {
                                    id: 'CreatedLocalDate', // Column ID
                                    header: _('Fecha de creación'), // Column header with localization
                                    fillspace: 0, // Fill space setting
                                    minWidth: 0, // Minimum width
                                    width: 120, // Column width
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Date formatting
                                    footer: 'Total:', // Footer text
                                },
                                {
                                    id: 'Country', // Column ID
                                    header: _('País'), // Column header with localization
                                    hidden: !devConfig.getPermAction('filterByCountry', 'Add'), // Conditional visibility based on permissions
                                    css: 'prm-filterByCountry', // CSS class for styling
                                    width: 80, // Column width
                                    sort: 'int', // Sorting type
                                    template: function (obj) {
                                        // Template for displaying country flags
                                        return "<i class='flags " + obj.Country + "'></i>";
                                    },
                                },
                                {
                                    id: 'UserId', // Column ID
                                    header: _('ID Usuario'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'UserName', // Column ID
                                    header: _('Nombre Usuario'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'BalanceInitial', // Column ID
                                    header: _('Saldo Inicial'), // Column header with localization
                                    width: 130, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                },
                                {
                                    id: 'InitialRechargeQuota', // Column ID
                                    header: _('Cupo recargas inicial'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'InitialGameQuota', // Column ID
                                    header: _('Cupo juego inicial'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'AmountDeposits', // Column ID
                                    header: _('Depósitos'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'AmountBets', // Column ID
                                    header: _('Ap. Deportivas'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'AmountWin', // Column ID
                                    header: _('Pr. Deportivas'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'AmountWinCasino', // Column ID
                                    header: _('Transf Apuesta E'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'AmountBetsCasino', // Column ID
                                    header: _('Transf Apuesta S'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'AdjustmentE', // Column ID
                                    header: _('Transf Recarga E'), // Column header with localization
                                    width: 80, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'AdjustmentS', // Column ID
                                    header: _('Transf Recarga S'), // Column header with localization
                                    width: 80, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'WithdrawPaid', // Column ID
                                    header: _('Retiros Pagados'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'WithdrawDeletes', // Column ID
                                    header: _('Recargas Eliminadas'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'BalanceEnd', // Column ID
                                    header: _('Saldo Final'), // Column header with localization
                                    width: 130, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'BalanceEndCalc', // Column ID
                                    header: _('Saldo Final Calc.'), // Column header with localization
                                    width: 130, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'BalanceGap', // Column ID
                                    header: _('Calc. Desfase'), // Column header with localization
                                    width: 110, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    cssFormat: mark_old, // CSS formatting function
                                },
                                {
                                    id: 'EndGameQuota', // Column ID
                                    header: _('Cupo final'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'EndGameQuotaCalc', // Column ID
                                    header: _('Cupo final Calc.'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                            ],
                            on: {
                                onBeforeLoad: function () {
                                    // Event before loading data
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    ); // Show loading overlay
                                },
                                onAfterLoad: function () {
                                    // Event after loading data
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            ready: function () {
                                // Event when the grid is ready
                                if (!this.count()) {
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>', // Show no data message
                                    );
                                }
                            },
                            footer: true, // Enable footer
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math calculations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view.
     * @param {Object} grid - The grid instance.
     */
    init(grid) {
        const id_partner = this.getParam('partner', true); // Retrieve partner ID from parameters
        grid = $$('datatable'); // Get the datatable instance
        var url = devConfig.geturlApi() + 'es/BalanceHistory/GetBalanceHistoryBetShop?Partner=' + id_partner + '&'; // API URL for fetching balance history
        var filter = ''; // Filter string

        grid.attachEvent('onAfterLoad', function () {
            // Event after data is loaded
            $$('datatable').data.group({
                by: 'Partner', // Group data by Partner
                map: {
                    Partner: ['Partner'], // Mapping for grouping
                },
            });
        });

        this.on(this.app, 'balanceHistory:filter', (filterData) => {
            // Event for applying filters
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Filter query string
            for (var i = 0; i < object.length; i++) {
                if (object[i][0] == 'Type') {
                    // Check for Type filter
                    if (object[i][1] == 0) {
                        grid.showColumn('UserId', { spans: true }); // Show UserId column
                        grid.showColumn('UserName', { spans: true }); // Show UserName column
                    } else {
                        grid.hideColumn('UserId', { spans: true }); // Hide UserId column
                        grid.hideColumn('UserName', { spans: true }); // Hide UserName column
                    }
                }
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object filter values
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', ''); // Format date
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom to query
                                string1 = string1 + '&dateTo=' + date; // Add dateTo to query
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Check for object filter values
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object for start
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format dateFrom
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object for end
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format dateTo
                                        string1 = string1 + '&' + dateTo; // Add dateTo to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            console.log(grid); // Log the grid instance
            string1 = string1 + '&Partner=' + id_partner; // Add partner ID to query
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
            filter = string1; // Update filter variable
        });

        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event after sorting
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event on item click
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        this.on(this.app, 'player:select', (Id) => {
            // Event for player selection
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data for selected player
            );
        });
    }
}

// FILE DOCUMENTED
